import { render, staticRenderFns } from "./MemberPrivileges.vue?vue&type=template&id=12327d60&scoped=true"
import script from "./MemberPrivileges.vue?vue&type=script&lang=js"
export * from "./MemberPrivileges.vue?vue&type=script&lang=js"
import style0 from "./MemberPrivileges.vue?vue&type=style&index=0&id=12327d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12327d60",
  null
  
)

export default component.exports